"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.namespace = 'playback';
exports.FETCH_PLAYBACK_META = exports.namespace + "/FETCH_PLAYBACK_META";
exports.FETCH_OFFLINE_PLAYBACK_META = exports.namespace + "/FETCH_OFFLINE_PLAYBACK_META";
exports.SET_PLAYBACK_META = exports.namespace + "/SET_PLAYBACK_META";
exports.STOP_PLAYBACK = exports.namespace + "/STOP_PLAYBACK";
exports.REMOVE_PLAYBACK_META = exports.namespace + "/REMOVE_PLAYBACK_META";
exports.REFRESH_PLAYBACK_HEARTBEAT = exports.namespace + "/REFRESH_PLAYBACK_HEARTBEAT";
exports.SET_PLAYBACK_HEARTBEAT = exports.namespace + "/SET_PLAYBACK_HEARTBEAT";
exports.SET_TEXT_TRACKS = exports.namespace + "/SET_TEXT_TRACKS";
exports.CLEAR_TEXT_TRACKS = exports.namespace + "/CLEAR_TEXT_TRACKS";
exports.SET_AUDIO_TRACKS = exports.namespace + "/SET_AUDIO_TRACKS";
exports.CLEAR_AUDIO_TRACKS = exports.namespace + "/CLEAR_AUDIO_TRACKS";
//# sourceMappingURL=constants.js.map